import { isFlashHotelOffer, isHotel, isVillaOffer } from 'lib/offer/offerTypes'

// Hide the price if all the following are true:
// - It's an anytime search (no dates, not flexible)
// - The canHideAnytimeNonFlashPrices flag is true
// - The offer is a hotel
// - The offer is NOT a flash offer
// - The occupancy is NOT standard
export default function isOfferInPriceHidingABTest(filters: App.OfferListFilters | undefined, offer: App.AnyOffer): boolean {
  // If it is not an anytime search
  if (filters?.checkIn || filters?.checkOut || filters?.flexibleNights) return false

  // If the canHideAnytimeNonFlashPrices flag is not true
  if (!filters?.hideAnytimeNonFlashPrices) return false

  // If the offer is not a hotel or villa offer, this doesn't apply
  if (!isHotel(offer) && !isVillaOffer(offer)) return false
  if (isFlashHotelOffer(offer)) return false

  if (!filters?.rooms?.length) return false

  return filters.rooms.some(room => {
    return room.adults !== 2 || !!room.children || !!room.infants
  })
}
